import React from 'react';
import PropTypes from 'prop-types';


const propTypes = {
    feedItem: PropTypes.object
};


export default class SimpleFeedItem extends React.Component{
    constructor(props) {
        super(props);
    }

    render() {

        let isSafari = window.safari !== undefined;

        const {feedItem} = this.props;

        const{img, title, subtitle, ctaLabel, ctaRoute, disclaimer} = feedItem;

        let isValid = ctaRoute;
        //console.log('cta route', ctaRoute);

        const cta = (
            <a className='square-cta-container' href={ctaRoute} download target='_blank'>{ctaLabel}
            </a>
        );

        return(
            <div>
                {isValid ?
                    <div className='feedi--item--holder'>
                        <div className='feedi--img--holder'>
                            <img src={img}/>
                        </div>
                        <div className='feed-content-holder'>
                            <div className='feed-item-copy-holder'>
                                <h4 className={isSafari === false ? 'feedi--title' : 'feedi--title-safari'}>{title}</h4>
                                <h4 className={isSafari === false ? 'feedi--title' : 'feedi--title-safari'}>{subtitle}</h4>
                            </div>
                            <div className='feed--item--cta--holder'>{cta}</div>
                        </div>
                    </div> :
                    <div className='feedi--item--holder'>
                        <div className='feedi--img--holder'>
                            <img src={img}/>
                        </div>
                        <div className='feed-content-holder'>
                            <div className='feed-item-copy-holder'>
                                <h4 className={isSafari === false ? 'feedi--title' : 'feedi--title-safari'}>{title}</h4>
                                <h4 className={isSafari === false ? 'feedi--title' : 'feedi--title-safari'}>{subtitle}</h4>
                            </div>
                            <div className='feed--item--disc--holder'>
                                <p className='disclaimer-text'>{disclaimer}</p>
                            </div>
                        </div>
                    </div>
                }
            </div>

        )
    }

}

SimpleFeedItem.propTypes = propTypes;



// WEBPACK FOOTER //
// ./src/components/SimpleFeed/SimpleFeedItem.js